import type { PanelView } from '../store/schema/TimePanelSettingsStore';
import type { TimePanelSelectedViewType } from 'owa-scenario-settings';

const panelViewToTypeMapping: { [T in PanelView]: TimePanelSelectedViewType } = {
    Conflicts: 'Calendar',
    EventDetails: 'Calendar',
    AttendeeTracking: 'Calendar',
    Calendar: 'Calendar',
    ComposeForm: 'Calendar',
    Tasks: 'Tasks',
    TaskDetails: 'Tasks',
};

export function getPanelViewType(view: PanelView): TimePanelSelectedViewType {
    if (!view) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (19,9): Type 'null' is not assignable to type 'TimePanelSelectedViewType'.
        // @ts-expect-error
        return null;
    }
    return panelViewToTypeMapping[view];
}
